import { countLoginBackgroundDefault, countLoginBackgroundSpecial } from './config/constant/assets/index';
import CryptoJS from 'crypto-js';

const storageName = {
  fullname: "KL908fdkn",
  accessToken: "JKLjfkj789",
  currentPage: 'pageTable',
  username: 'rememberme',
  colorProfile:'#F16F24',
  flagColor:1,
  flagBg : 1,
};

const KEY = import.meta.env.VITE_CRYPTO_KEY; // Panjang 32 byte
const IV = import.meta.env.VITE_CRYPTO_IV; // Panjang 16 byte

export const lanSetting = {
  lan_set:'SWzYW',
  user_id:'3q0sw',
  lan:'1OoFf'
}


export const decryptData = (encryptedData) => {
  let decryptedWA = CryptoJS.AES.decrypt(
    encryptedData,                                              // Pass ciphertext Base64 encoded (or as CipherParams object)
    CryptoJS.enc.Utf8.parse(KEY),
    {
        iv: CryptoJS.enc.Utf8.parse(IV),    // UTF8 encode the IV 
        mode: CryptoJS.mode.CBC,    // default
        padding: CryptoJS.pad.Pkcs7 // default              // Apply PKCS7 padding
    }
  );

  let decryptedB64 =  decryptedWA.toString(CryptoJS.enc.Utf8); 
  let decrypted = CryptoJS.enc.Utf8.parse(decryptedB64).toString(CryptoJS.enc.Utf8); // Base64 decode the decrypted data

  // console.log(typeof(decrypted))
  // console.log(decrypted)
  return JSON.parse(decrypted);
};

export const encryptData = (data) => {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CryptoJS.enc.Utf8.parse(KEY),
        { iv: CryptoJS.enc.Utf8.parse(IV), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    const enc = encrypted.toString();
    // const replaceSlash = enc.replace(/\//g, '_');
    return enc;
};

export const replaceSpecialChart = (value) => {
  let text;
  text = value.replace(/[\^]/g, "");
  return text;
};

export const setFullname = (value) => {
  localStorage.setItem(storageName.fullname, value);
};

export const getFullname = () => {
  const name = localStorage.getItem(storageName.fullname);

  if (!name) return null;

  return name;
};

export const setCurrentPageTable = (value) => {
  localStorage.setItem(storageName.currentPage, value);
}

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);
}

export const getLocalStorage = (name) => {
  const item = localStorage.getItem(name);

  if (!item) return [];

  return item;
};

export const getLocalStorageNewCl = (name) => {
  const item = localStorage.getItem(name);

  if (!item) return [];

  return item;
};

export const getCurrentPageTable = () => {
  const page = localStorage.getItem(storageName.currentPage);

  if (!page) return 1;

  return page;
};

// Local Storage - Access Token
export const setAccessToken = (value) => {
  localStorage.setItem(storageName.accessToken, value);
};

export const setCookies = (cookieName, cookieValue) => {
  document.cookie = cookieName + " = " + cookieValue + "; SameSite=None; Secure";
};

export const setCookiesExpire = (cookieName, cookieValue, expiredDate) => {
  document.cookie = cookieName + " = " + cookieValue + "; expires="+expiredDate+"; SameSite=None; Secure";
};


export const getAccessToken = () => {
  const token = localStorage.getItem(storageName.accessToken);

  if (!token) return null;

  return token;
};

export const clearStorage = () => {
  localStorage.removeItem(storageName.fullname);
  localStorage.removeItem(storageName.accessToken);
  localStorage.removeItem(storageName.currentPage);
  localStorage.removeItem('search_cl');
  localStorage.removeItem('search_mylj');
};

// Cleansing Object
export function cleanObject(obj) {
  let normalize = obj;
  const propNames = Object.getOwnPropertyNames(normalize);

  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (
      normalize[propName] === null ||
      normalize[propName] === undefined ||
      normalize[propName] === ""
    ) {
      delete normalize[propName];
    }
  }

  return normalize;
}

export const extractInitial = (name) => {

  if (!name) return null;
  // Split the name into separate words
  const words = name.split(" ");
  const firstName = words[0].charAt(0);
  let middleName = "";
  if (words[1]) {
    middleName = words[1].charAt(0);
  }

  // Get the first letter of each word and join them together
  const initial = `${firstName}${middleName}`;

  return initial.toUpperCase();
};

//Safe username for remember me
export const setUsername = (value) => {
  localStorage.setItem(storageName.username, value);
};

export const setDataForm = (name, value) => {
  localStorage.setItem(name, value);
};

export const getDataForm = (key) => {
  const data = localStorage.getItem(key);

  if (!data) return null;

  return data;
};

export const clearDataForm = (key) => {
  localStorage.removeItem(key);
};

export const getUsername = () => {
  const name = localStorage.getItem(storageName.username);

  if (!name) return null;

  return name;
};

export const getCompanyName = () => {
  const companyName = import.meta.env.VITE_COMPANY_NAME;

  return companyName;
}

export const getAppName = () => {
  const appName = import.meta.env.VITE_PROJECT_TITLE;

  return appName;
}

export const randBg = () => {  
  const randDefault = () => {
    const number = Math.floor(Math.random() * countLoginBackgroundDefault);
    
    document.body.style.background=`url(/assets/login/background/default/BG-Default-${number+1}.png)`;
    document.body.style.backgroundSize = 'cover'; 
    document.body.style.backgroundRepeat = 'no-repeat'; 
    document.body.style.backgroundPosition = 'bottom'; 
  }
  
  const randSpecial = () => {
    const number = Math.floor(Math.random() * countLoginBackgroundSpecial);
    document.body.style.background=`url(/assets/login/background/special/BG-Special-${number+1}.png)`; 
    document.body.style.backgroundSize = 'cover'; 
    document.body.style.backgroundRepeat = 'no-repeat'; 
    document.body.style.backgroundPosition = 'bottom'; 
  }

  //get special date from env
  const specialDate = import.meta.env.VITE_SPECIAL_DATE;
  
  //get current date
  const date = new Date().getDate();
  const month = new Date().getMonth();
  const year = new Date().getFullYear();
  const today = `${month+1}-${date < 9 ? '0'+date : date}-${year}`;
  
  if (storageName.flagBg == 1) {
    if(specialDate != ""){
      const find = specialDate.indexOf("/");
      
      if(find>-1) {
        const special = specialDate.split("/");

        if(today>=special[0] && today<=special[1]){
          randSpecial();
        } else {
          randDefault();
        }
      } else {
        if(today == specialDate){
          randSpecial();
        } else {
          randDefault();
        }
      }
    } else {
      randDefault();
    }

    storageName.flagBg = 0;
  }
}

export const randColor = () => {

  if(storageName.flagColor == 1) {
    storageName.colorProfile = '#'+Math.floor(Math.random()*16777215).toString(16);
    storageName.flagColor = 0;
  }

  return(storageName.colorProfile);
}